import React, { Component, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Helmet } from 'react-helmet';
import { withSize } from 'react-sizeme';

import GlobalStyles from './global-styles';
import Footer from './Footer';
import Header from './Header/Header';
import EmergencyContact from './EmergencyContact';
import Theme from './Theme';
import useGlobal from '../store';
const LayoutStyled = styled.div`
    width: 100%;
    max-width: 1440px;
    margin: auto;
    background-color: ${(props) => props.theme.colors.white};

    dtn-select {
        background: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='16px' height='8px' viewBox='0 0 16 8' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3EF64E9AD2-9F78-4EA9-8DC8-6D130559F8A2%3C/title%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Web-2038---GA-Contact-Copy' transform='translate(-656.000000, -660.000000)' fill='%23333300' fill-rule='nonzero'%3E%3Cpolygon id='Path' points='656 660 664 668 672 660'%3E%3C/polygon%3E%3C/g%3E%3C/g%3E%3C/svg%3E")
            no-repeat right 20px bottom/16px 45px;
    }
`;
const Layout = ({ ...props }) => {
    const { children, size, path } = props;
    const [bgIsWhite, setBgIsWhite] = useState(false);
    const [globalState, globalActions] = useGlobal();
    useEffect(() => {
        let pathname = window.location.pathname;

        if (pathname.length > 1) {
            pathname = pathname.replace(/\/+$/, '');
        }
        if (
            window.location.pathname === '/' ||
            window.location.pathname === '/contact' ||
            window.location.pathname === '/corn-bids' ||
            window.location.pathname === '/terms-conditions'
        ) {
            window.addEventListener('scroll', handleScroll);
        } else {
            setBgIsWhite(true);
        }
        if (window.scrollY > 34) {
            window.removeEventListener('scroll', handleScroll);
        }
        if (globalState?.header?.header_status !== 'SUCCESS') {
            globalActions.HeaderContentService.getHeaderContent();
        }
        if (globalState?.footer?.footer_status !== 'SUCCESS') {
            globalActions.FooterContentService.getFooterContent();
        }
        if (pathname === '/' && globalState?.home?.home_status !== 'SUCCESS') {
            globalActions.HomeContentService.getHomeContent();
        } else if (
            pathname === '/contact' &&
            globalState?.contact?.contact_status !== 'SUCCESS'
        ) {
            globalActions.ContactContentService.getContactContent();
        } else if (
            pathname === '/corn-bids' &&
            globalState?.cornbids?.cornbids_status !== 'SUCCESS'
        ) {
            globalActions.CornBidsContentService.getCornBidsContent();
        } else if (
            pathname === '/terms-conditions' &&
            globalState?.termscondition?.termscondition_status !== 'SUCCESS'
        ) {
            globalActions.TermsConditionContentService.getTermsConditionContent();
        }
    }, [window.scrollY]);

    const handleScroll = (event) => {
        const isScrolled = event.srcElement.scrollingElement.scrollTop;
        setBgIsWhite(isScrolled > 34 || window.location.pathname !== '/');
        if (window.location.pathname === '/contact') {
            setBgIsWhite(
                isScrolled > 34 || window.location.pathname !== '/contact'
            );
        }
        if (window.location.pathname === '/corn-bids') {
            setBgIsWhite(
                isScrolled > 34 || window.location.pathname !== '/corn-bids'
            );
        }

        if (window.location.pathname === '/terms-conditions') {
            setBgIsWhite(
                isScrolled > 34 ||
                    window.location.pathname !== '/terms-conditions'
            );
        }
    };
    return (
        <Theme>
            <LayoutStyled>
                <Helmet>
                    <link
                        href="https://fonts.googleapis.com/css2?family=Lato:wght@300;400;600;700&family=Lora:wght@400;700&display=swap&family=Open+Sans:wght@400;700&display=swap&family=Roboto:wght@400;700&display=swap"
                        rel="stylesheet"
                    />
                </Helmet>

                <Header isHomepageHeader={!bgIsWhite} windowSize={size} />

                <main className="container"> {children}</main>
                <Footer />
                <EmergencyContact />
            </LayoutStyled>
            <GlobalStyles />
        </Theme>
    );
};

export default withSize()(Layout);
